import React from 'react';
import { Button } from './ui/Button';
import { ShieldCheck, Lock } from 'lucide-react';
import { trackAddToCartThenNavigate } from '../utils/metaPixel';
export function PricingCta() {
  return <section id="pricing" className="py-14 md:py-18 bg-[#0a0e1a] relative overflow-hidden" data-id="element-133">
      {/* Background Glows */}
      <div className="absolute top-0 left-0 w-full h-full bg-grid-pattern opacity-10 pointer-events-none" data-id="element-134"></div>
      <div className="absolute bottom-0 right-0 w-[500px] h-[500px] bg-[#f59e0b]/10 rounded-full blur-[100px] pointer-events-none" data-id="element-135"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-136">
        <div className="max-w-4xl mx-auto bg-[#111827] border border-[#00d4aa] rounded-3xl p-8 md:p-12 shadow-[0_0_50px_rgba(0,212,170,0.15)] text-center" data-id="element-137">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-138">
            Obtén el sistema completo <br data-id="element-139" />
            <span className="text-[#00d4aa]" data-id="element-140">"De Gamer a Creador"</span> hoy
            mismo
          </h2>

          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto" data-id="element-141">
            Deja de pelear con la consola y empieza a construir el futuro de tu
            hijo.
          </p>

          <div className="flex flex-col items-center justify-center mb-10" data-id="element-142">
            <span className="text-gray-500 text-lg line-through mb-2" data-id="element-143">
              $19 USD
            </span>
            <div className="flex items-baseline gap-2" data-id="element-144">
              <span className="text-6xl font-black text-white" data-id="element-145">$6.36</span>
              <span className="text-xl text-gray-400 font-medium" data-id="element-146">USD</span>
            </div>
            <span className="bg-[#f59e0b]/20 text-[#f59e0b] px-3 py-1 rounded-full text-sm font-bold mt-4 border border-[#f59e0b]/30" data-id="element-147">
              Inversión Única
            </span>
          </div>

          <div className="max-w-md mx-auto space-y-4" data-id="element-148">
            <Button size="xl" fullWidth className="text-lg shadow-[0_0_30px_rgba(0,212,170,0.4)] animate-pulse hover:animate-none" onClick={() => {
            trackAddToCartThenNavigate('https://www.nuevohabito.com/cart/44880645324834:1');
          }} data-id="element-149">
              ¡SÍ, QUIERO TRANSFORMAR LA ADICCIÓN DE MI HIJO!
            </Button>

            <p className="text-sm text-gray-500 flex items-center justify-center gap-2" data-id="element-150">
              <Lock className="h-3 w-3" data-id="element-151" />
              Acceso instantáneo al PDF tras la compra segura.
            </p>
          </div>

          <div className="mt-8 pt-8 border-t border-gray-800 flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-400" data-id="element-152">
            <div className="flex items-center gap-2" data-id="element-153">
              <ShieldCheck className="h-5 w-5 text-[#00d4aa]" data-id="element-154" />
              <span data-id="element-155">Garantía de satisfacción 100%</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-156">
              <ShieldCheck className="h-5 w-5 text-[#00d4aa]" data-id="element-157" />
              <span data-id="element-158">Pago seguro SSL</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}